import api from '../../services/api';
import logger from '../../utils/logger';

export default function createPropertySearchService() {
  let properties = [];
  let isLoading = false;

  function getData() {
    return properties;
  }

  function getLoadingState() {
    return isLoading;
  }

  async function loadProperties() {
    isLoading = true;
    try {
      const data = await api.getCentresLookupList();
      properties = Array.isArray(data) ? data : [];
      return properties;
    } catch (error) {
      logger.error('Error fetching properties:', error);
      properties = [];
      return properties;
    } finally {
      isLoading = false;
    }
  }

  return { getData, getLoadingState, loadProperties };
}
